import React from "react";
import * as Styles from "./styles/BottomNavigation";
import * as Text from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import {
    IconArrowRightLong,
    IconArrowLeftLong,
} from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import useSiblingStepLink from "../../../../hooks/shared/actions/useSiblingStepLink";
import { useBnbSelector } from "../../../../redux/store";
import ButtonPrimary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonWithIcon from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { isRTL } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { getBnbPriceConfig } from "../../../../utils/settings/bnbFinanceSettingUtils";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { isPassiveSummary } from "../../../../utils/settings/bnbSettingUtils";

const BottomNavigation = (): JSX.Element | null => {
    const nextStepLink = useSiblingStepLink("next");
    const prevStepLink = useSiblingStepLink("prev");
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const priceConfig = useBnbSelector((state) =>
        getBnbPriceConfig(state.commonSettings, state.car.model.internalCode, state.navigation.step),
    );
    const isRtl = useBnbSelector((state) => isRTL(state.commonSettings));

    const passiveSummary = isPassiveSummary(commonSettings); // Hide back to customization button
    const showNextLink = nextStepLink && (!priceConfig.priceEnabled || !showPrice(commonSettings)); // show when price is disabled (financetoggle panel is hiden in this case)
    const showPrevLink = prevStepLink && !passiveSummary;

    if (!showPrevLink && !showNextLink) return null;
    return (
        <Styles.Wrapper>
            {showPrevLink ? (
                <ButtonWithIcon hasIconLeft href={prevStepLink.url} onClick={prevStepLink.go}>
                    <Text.IconButton>{prevStepLink.label}</Text.IconButton>
                    {isRtl ? <IconArrowRightLong /> : <IconArrowLeftLong />}
                </ButtonWithIcon>
            ) : (
                // empty div needed for flexbox
                <div />
            )}
            {showNextLink && (
                <ButtonPrimary href={nextStepLink?.url} onClick={nextStepLink?.go}>
                    {nextStepLink?.label}
                </ButtonPrimary>
            )}
        </Styles.Wrapper>
    );
};
export default BottomNavigation;
